export default __webpack_public_path__ + "static/media/STELLA.9c405a13.png";